import { setCookie } from "../modules/cookies";

class ConsentBanner {
    
    constructor() {
        this.set();
        this.init();
    }

    set() {
        this.root = document.querySelector(".consent-banner");
        this.acceptButton = this.root.querySelector(".js-accept-consent");
    }

    init() {
        this.root.classList.add("-active");
        if (this.acceptButton) {
            this.acceptButton.addEventListener("click", this.saveConsentMode.bind(this));
        }
    }

    saveConsentMode() {
        setCookie("mda_consent_banner", true, 30);
        this.root.classList.remove("-active");
    }

}

new ConsentBanner();